import { Download } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnDownloadLabelEditorRenderer } from "./editor";
import { ReturnDownloadLabelEmailRenderer } from "./email";
import { ReturnDownloadLabelPanelRenderer } from "./email-panel";
import type { ReturnDownloadLabelBlockProps } from "./types";

export default registerBlock<ReturnDownloadLabelBlockProps>({
  type: "return-download-label",
  name: "editorBlocksLibrary.blocks.return-download-label.title",
  description: "editorBlocksLibrary.blocks.return-download-label.description",
  Icon: Download,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  // The auto labels cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnDownloadLabelEmailRenderer,
      editor: {
        component: ReturnDownloadLabelEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ReturnDownloadLabelPanelRenderer,
      },
      compatibility: {
        rowBlock: true,
      },
    },
  },
});

export type { ReturnDownloadLabelBlockProps } from "./types";
